import { FunctionComponent } from "react";

interface FormDetailItemProps {
  title: string | JSX.Element;
  description: string | JSX.Element | JSX.Element[] | undefined;
  className?: string;
}

const FormDetailItem: FunctionComponent<FormDetailItemProps> = ({
  title,
  description,
  className = "",
}) => {
  return (
    <div
      className={`app-item-detail-form ${className}`}
      data-test="input-label"
      data-alt={title}
      data-test-for="name"
    >
      <div className="item-title">{title}</div>
      <p className="item-description" data-test={"name"}>
        {description}
      </p>
    </div>
  );
};

export default FormDetailItem;
